import { SPONSORED_ADS_PROVIDER_IDS } from "src/utils/constants";
import {adBlockingRecoveryScript} from "./adBlockingRecoveryScript";
import { customJs } from "../../utils/customJs";
import { isValidStyleId } from "src/utils";

const handleBrand = (brand) => {
  if (!brand || brand === 'undefined') {
    return '';
  }
  return brand;
}

export const overridePostback = (requestKey, postbackKey, bqValue) => {
  if (requestKey.length !== postbackKey.length) {
    return bqValue;
  }
  for (let i = 0; i < requestKey.length; ++i) {
    const paramValue = bqValue[requestKey[i]];
    if ([requestKey[i]] in bqValue) {
      bqValue = { ...bqValue, [postbackKey[i]]: paramValue ? paramValue : "" };
      delete bqValue[requestKey[i]];
    }
  }

  return bqValue;
};

export const createGoogleCustomSearchScript = (params, gsceBQData, sendClientEventsExtraParams, targetWindow) => {
  const { query, pubId, channel, maxTop, adtest, styleId: defaultStyleId, hl, secondAdBlock, secondBlockAdCount } = params;
  const { searchParams: { searchTerm, brand, clientId, variant, serpLayoutVariant }, reqId, URL, country } = gsceBQData;
  const {
    sponsoredSearchResults2ClientImpressionsURL,
    sponsoredSearchResults2AllParams,
    sponsoredSearchResults2OverridePostbackCheck,
    sponsoredSearchResults2OverrideRequestKeys,
    postbackConfig,
    sponsoredSearchResults2OverridePostbackKeys
  } = sendClientEventsExtraParams;

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let dynamicStyleId = defaultStyleId;
  const useValue = urlParams.get('use') || 1;

  if (useValue && ['1', '2', '3'].includes(useValue)) {
    const styleIdKey = `styleId${useValue}`;
    const styleId = urlParams.get(styleIdKey);
    dynamicStyleId = isValidStyleId(styleId) ? styleId : defaultStyleId;
  }

  const adSenseScript = document.createElement("script");
  adSenseScript.src = "https://www.google.com/adsense/search/ads.js";


  adSenseScript.async = true;
  document.head.appendChild(adSenseScript);

  const googleCsaLoader = document.createElement("script");
  googleCsaLoader.type = "text/javascript";
  googleCsaLoader.innerHTML = `
    (function(g,o){g[o]=g[o]||function(){(g[o]['q']=g[o]['q']||[]).push(
    arguments)},g[o]['t']=1*new Date})(window,'_googCsa');
  `;

  document.head.appendChild(googleCsaLoader);
  const loadAdsScript = document.createElement("script");
  loadAdsScript.type = "text/javascript";

  const pageOptions = JSON.stringify({
    hl,
    pubId,
    styleId: dynamicStyleId,
    adtest,
    channel,
    linkTarget: targetWindow === '_blank' ? '_blank' : '_top'
  });

  let customPostbackCalled = false;
  window[`gcaCallbackFunction`] = function(containerName, adsLoaded) {
    window[`adsLoaded-${containerName}`] = adsLoaded;
    const now = new Date();
    var bqValues = {
      searchTerm: searchTerm,
      brand: handleBrand(brand),
      reqId: reqId,
      datetime: now.toISOString(),
      clientID: `${clientId}`,
      provider: SPONSORED_ADS_PROVIDER_IDS.GOOGLE.name,
      URL: URL,
      country: country,
      variant: serpLayoutVariant || variant,
      style_name: dynamicStyleId || null,
      userId: window.visitorId,
      sessionId: window.afSessionId ? window.afSessionId : null,
      searchAdShown: adsLoaded ? "yes" : "no",
      index: NaN,
      userLocalDatetime: now.toISOString(),
      rGuid: containerName
    };

    if (window.afExtraParams) {
      bqValues = { ...bqValues, ...window.afExtraParams };
    }

    var xhr = new XMLHttpRequest();
    xhr.open("POST", afBqFillRateURL, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify(bqValues));

    if (postbackConfig.type === 'customJS' && postbackConfig.impressionJS && adsLoaded && !customPostbackCalled) {
      customJs(postbackConfig.impressionJS, bqValues);
      customPostbackCalled = true;
    }

    if (sponsoredSearchResults2AllParams) {
      const urlParams = new URLSearchParams(window.location.search);
      bqValues = { ...bqValues, ...Object.fromEntries(urlParams) };
    }

    if (sponsoredSearchResults2OverridePostbackCheck && sponsoredSearchResults2OverrideRequestKeys && sponsoredSearchResults2OverridePostbackKeys) {
      const requestKeys = sponsoredSearchResults2OverrideRequestKeys
        .trim()
        .split(",")
        .filter(val => val.trim() != "");
      const postbackKeys = sponsoredSearchResults2OverridePostbackKeys
        .trim()
        .split(",")
        .filter(val => val.trim() != "");
        bqValues = overridePostback(requestKeys, postbackKeys, bqValues);
    }

    if (sponsoredSearchResults2ClientImpressionsURL && adsLoaded) {
      var xhr2 = new XMLHttpRequest();
      let clientEndpoint = sponsoredSearchResults2ClientImpressionsURL;
      clientEndpoint += clientEndpoint.indexOf("?") > -1 ? "&" : "?";
      clientEndpoint += new URLSearchParams(bqValues).toString();
      xhr2.open("GET", clientEndpoint, true);
      xhr2.send();
    }
  };

  var adblock1 = {
    container: "afscontainer1",
    maxTop: maxTop,
    query: query,
    adLoadedCallback: "adLoadedCallbackPlaceholder"
  };

  let googleScript = `_googCsa('ads', ${pageOptions}, ${JSON.stringify(adblock1).replace(`"adLoadedCallbackPlaceholder"`, `window[\`gcaCallbackFunction\`]`)});`;
  if (secondAdBlock) {
    var adblock2 = {
      container: "afscontainer2",
      query: query,
      number: secondBlockAdCount,
      adLoadedCallback: "adLoadedCallbackPlaceholder",
    };
    const organicDiv = document.querySelector(".search-results")
    if (organicDiv) {
      const adBlockDiv = document.createElement("div");
      adBlockDiv.id = "afscontainer2";
      organicDiv.insertAdjacentElement('afterend', adBlockDiv);
      googleScript = `_googCsa('ads', ${pageOptions}, ${JSON.stringify(adblock1).replace(`"adLoadedCallbackPlaceholder"`, `window[\`gcaCallbackFunction\`]`)}, ${JSON.stringify(adblock2).replace(`"adLoadedCallbackPlaceholder"`, `window[\`gcaCallbackFunction\`]`)});`;
    }
  }

  const domain = window.GLOBALS.API.EVENT_TRACKER_URI;
  const afBqFillRateURL = domain + "/bq/d2SFillRate/v1";
  loadAdsScript.innerHTML = googleScript;
  document.body.appendChild(loadAdsScript);
  adBlockingRecoveryScript(pubId);

};
